/**
 * The tbs.event.Event class works as the entity object for the 
 * event dispatcher.
 * It contains some public properties only now.
 * @class org.bn.msf.event.Event
 */
const tbs_event_Event = function(type, data, target) {
    // console.log("event", type, data);
    //--------------------------------------------------
    // private properties
    //--------------------------------------------------
    let _status = this.AVAIL;
    let _reversePropagation;
    //--------------------------------------------------
    // privileged setter and getter
    //--------------------------------------------------
    /**
     * @privileged setter and getter
     */
    this.p_status = function(value) {
        if (arguments.length > 0) {
            _status = value;
        }
        else {
            return _status;
        }
    };
    /**
     * @privileged setter and getter
     */
    this.p_reversePropagation = function(value) {
        if (arguments.length > 0) {
            _reversePropagation = value;
        }
        else {
            return _reversePropagation;
        }
    };
    //--------------------------------------------------
    // public properties
    //--------------------------------------------------
    this.type = type;
    this.data = data;
    this.target = target;

    this.isEvent = true;
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_event_Event.prototype = {
    //--------------------------------------------------
    // public static value
    //--------------------------------------------------
    AVAIL: "avail",
    STOPPED: "stopped",
    //--------------------------------------------------
    // setter and getter
    //--------------------------------------------------
    /**
     * @setter and getter
     * Set the reversePropagation value with boolean value.
     * Get the reversePropagation value.
     */
    reversePropagation: function(value) {
        if (arguments.length > 0) {
            this.p_reversePropagation(value);
        }
        else {
            return this.p_reversePropagation();
        }
    },
    //--------------------------------------------------
    // api
    //--------------------------------------------------
    /**
     * @api
     * Stop the event propagation.
     * Set the event status as STOPPED value.
     */
    stopPropagation: function() {
        this.p_status(this.STOPPED);
    },
    /**
     * @api
     * Check the event available or not.
     */
    checkAvail: function() {
        if (this.p_status() == this.STOPPED) {
            return false;
        }
        else {
            return true;
        }
    }
}

module.exports = tbs_event_Event